import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

/** The team the page is for: the slug in the URL, else the remembered one. */
export default function useTeamId() {
  const { team: teamFromUrl } = useParams();
  const [teamFromStorage, setTeam] = useState(() => (typeof window === 'undefined' ? '' : localStorage.getItem('selectedTeam') || ''));
  useEffect(() => {
    const onStorage = (e) => { if (e.key === 'selectedTeam') setTeam(e.newValue || ''); };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);
  return teamFromUrl || teamFromStorage;
}
